import PropTypes from 'prop-types'
import React from 'react'
import useError from '../hooks/useError'
import useWarning from '../hooks/useWarning'
import InputEditable from './InputEditable'

const ListaOrdenadaEditable = React.forwardRef((props, ref) => {
  const {
    name,
    type,
    label,
    classLista,
    classLabel,
    classInput,
    disabled,
    texto,
    value,
    placeholder,
    onChange,
    onClickOutSide,
    onFocus,
    onFocusSelected,
    errores,
    warnings
  } = props
  const { ShowError, hayError } = useError(errores, name)
  const { ShowWarning, hayWarning } = useWarning(warnings, name)

  const obtenerClases = () => {
    const classes = []
    if (classLista) {
      classes.push(classLista)
    }
    if (disabled) {
      classes.push('disabled')
    }
    if (hayError) {
      classes.push('error')
    }
    if (hayWarning) {
      classes.push('warning')
    }
    return classes.join(' ')
  }

  return (
    <>
      <li className={obtenerClases()}>
        <span className="spanDatosPersonales">{label}</span>&nbsp;
        <InputEditable
          ref={ref}
          name={name}
          type={type}
          onChange={onChange}
          texto={texto}
          classInput={classInput}
          classLabel={classLabel}
          onClickOutSide={onClickOutSide}
          value={value}
          placeholder={placeholder}
          onFocus={onFocus}
          onFocusSelected={onFocusSelected}
          disabled={disabled}
        />
      </li>
      {<ShowError />}
      {<ShowWarning />}
    </>
  )
})

InputEditable.defaultProps = {
  type: 'text'
}

ListaOrdenadaEditable.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'email', 'date', 'number', 'password']),
  label: PropTypes.string.isRequired,
  classLista: PropTypes.string,
  classLabel: PropTypes.string,
  classInput: PropTypes.string,
  disabled: PropTypes.bool,
  texto: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClickOutSide: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onFocusSelected: PropTypes.bool,
  errores: PropTypes.object,
  warnings: PropTypes.object
}

ListaOrdenadaEditable.displayName = 'ListaOrdenadaEditable'

export default ListaOrdenadaEditable
